// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link, mat-form-field { width: 540px; }
.margin-top { display: block; margin-top: 1.5em; }
textarea { resize: none;}
input, textarea { outline: none}
.error { font-size: 13px; color: #d32f2f; margin-top: 5px; }
.link { color: #555; padding: .5em; }
.divEditor {
   margin-top: 5px;
   border: 1px solid;
   padding: 5px;
   max-width: 540px;
   overflow-y: auto;
   max-height: 100px;
}
.flex-container {
   display: flex;
   flex-wrap: wrap;
}
.span-email {
   border: 1px solid #333333;
   border-radius: 10px;
   background-color: #00b2c9;
   color: white;
   margin: 2px 5px;
   padding: 2px 5px;
   display: inline-block;
   max-width: 500px;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
}
.x {
   cursor: pointer;
   margin-left: 10px;
   font-size: 12px;
}
#textArea { border: none; }
.flex-container > input {
   width: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/share-to-email/share-to-email.component.css"],"names":[],"mappings":"AAAA,wBAAwB,YAAY,EAAE;AACtC,cAAc,cAAc,EAAE,iBAAiB,EAAE;AACjD,WAAW,YAAY,CAAC;AACxB,kBAAkB,aAAa;AAC/B,SAAS,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAC3D,QAAQ,WAAW,EAAE,aAAa,EAAE;AACpC;GACG,eAAe;GACf,iBAAiB;GACjB,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,iBAAiB;AACpB;AACA;GACG,aAAa;GACb,eAAe;AAElB;AACA;GACG,yBAAyB;GACzB,mBAAmB;GACnB,yBAAyB;GACzB,YAAY;GACZ,eAAe;GACf,gBAAgB;GAChB,qBAAqB;GACrB,gBAAgB;GAChB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;AAC1B;AACA;GACG,eAAe;GACf,iBAAiB;GACjB,eAAe;AAClB;AACA,YAAY,YAAY,EAAE;AAC1B;GACG,UAAU;AACb","sourcesContent":[".link, mat-form-field { width: 540px; }\n.margin-top { display: block; margin-top: 1.5em; }\ntextarea { resize: none;}\ninput, textarea { outline: none}\n.error { font-size: 13px; color: #d32f2f; margin-top: 5px; }\n.link { color: #555; padding: .5em; }\n.divEditor {\n   margin-top: 5px;\n   border: 1px solid;\n   padding: 5px;\n   max-width: 540px;\n   overflow-y: auto;\n   max-height: 100px;\n}\n.flex-container {\n   display: flex;\n   flex-wrap: wrap;\n   -webkit-flex-flow: wrap;\n}\n.span-email {\n   border: 1px solid #333333;\n   border-radius: 10px;\n   background-color: #00b2c9;\n   color: white;\n   margin: 2px 5px;\n   padding: 2px 5px;\n   display: inline-block;\n   max-width: 500px;\n   overflow: hidden;\n   white-space: nowrap;\n   text-overflow: ellipsis;\n}\n.x {\n   cursor: pointer;\n   margin-left: 10px;\n   font-size: 12px;\n}\n#textArea { border: none; }\n.flex-container > input {\n   width: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
